export const LIVE_WIN_ANIMATION_DURATION = 450
export const LIVE_WIN_MAX_ITEM = 30
export const LIVE_WIN_PAUSE_ANIMATION_DURATION = 250
